import * as R from 'ramda';
// helpers
import * as H from './helpers';
import { isStaging, isDevelopment } from './env';
//////////////////////////////////////////////////

// localStorage
const setStorage = (data) => localStorage.setItem('storage', JSON.stringify(data)); // eslint-disable-line
// set/get/remove item
const removeItemFromLocalStorage = (name) => localStorage.removeItem(name); // eslint-disable-line
const getItemFromLocalStorage = (name) => JSON.parse(localStorage.getItem(name)); // eslint-disable-line
const setItemToLocalStorage = (name, data) =>
  localStorage.setItem(name, JSON.stringify(data)); // eslint-disable-line
// sessionStorage
const removeAuthTokenFromSession = () => sessionStorage.removeItem('theamoustoken'); // eslint-disable-line
const removeRefreshTokenFromSession = () => sessionStorage.removeItem('refreshToken'); // eslint-disable-line
const getAuthTokenFromSession = () => JSON.parse(sessionStorage.getItem('theamoustoken')); // eslint-disable-line
const getRefreshTokenFromSession = () => JSON.parse(sessionStorage.getItem('refreshToken')); // eslint-disable-line
const setAuthTokenToSession = (token) => sessionStorage.setItem('theamoustoken', JSON.stringify(token)); // eslint-disable-line
const setRefreshTokenToSession = (token) => sessionStorage.setItem('refreshToken', JSON.stringify(token)); // eslint-disable-line
// branch guid
const getCurrentBranchGuid = () => sessionStorage.getItem('currentBranchGuid'); // eslint-disable-line
const removeCurrentBranchGuid = () => sessionStorage.removeItem('currentBranchGuid'); // eslint-disable-line
const setCurrentBranchGuid = (guid) => sessionStorage.setItem('currentBranchGuid', guid); // eslint-disable-line

const approximateTimeout = 60;
const setAuthTokenExpirationToSession = (expiresIn) => {
  const expirationTime = new Date().getTime() + ((expiresIn - approximateTimeout) * 1000);

  sessionStorage.setItem('authTokenExpiration', expirationTime); // eslint-disable-line
};

const isAuthTokenExpired = () => sessionStorage.getItem('authTokenExpiration') <= new Date().getTime(); // eslint-disable-line

const getIsDevModeFromSession = () => sessionStorage.getItem('isDevMode'); // eslint-disable-line
const setIsDevModeToSession = (isDevMode) => sessionStorage.setItem('isDevMode', isDevMode); // eslint-disable-line

const toggleDevMode = () => {
  if (H.isAllFalse(isStaging, isDevelopment)) return;

  setIsDevModeToSession(R.not(R.equals(getIsDevModeFromSession(), 'true')));
};

const isDevMode = () => R.or(R.equals(getIsDevModeFromSession(), 'true'), false);

export {
  isDevMode,
  setStorage,
  toggleDevMode,
  isAuthTokenExpired,
  setCurrentBranchGuid,
  getCurrentBranchGuid,
  setIsDevModeToSession,
  setItemToLocalStorage,
  setAuthTokenToSession,
  getIsDevModeFromSession,
  getItemFromLocalStorage,
  removeCurrentBranchGuid,
  getAuthTokenFromSession,
  setRefreshTokenToSession,
  removeItemFromLocalStorage,
  removeAuthTokenFromSession,
  getRefreshTokenFromSession,
  removeRefreshTokenFromSession,
  setAuthTokenExpirationToSession,
};
